const proAlertsAPI = 'https://pro-alerts-api-production.up.railway.app/api/v1'

export default proAlertsAPI;